import React from 'react';

export type TWithOnMountHandler<T> = { action?: (userType?: unknown) => void; isOpen: boolean } & T;

export function withOnModalOpenHandler<T extends Record<string, unknown>>(
  WrappedComponent: React.FC<Omit<T, 'action'>>,
) {
  const Component: React.FC<TWithOnMountHandler<T>> = ({ action, ...props }) => {
    React.useEffect(() => {
      if (props?.isOpen) {
        action?.();
      }
    }, [props?.isOpen]);

    return <WrappedComponent {...props} />;
  };

  return Component;
}
